module.exports = __webpack_public_path__ + "img/favicon.f5b5f02.png";